import { type ReactNode } from "react";

interface SceneContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Scene wrapper with mount-only fade/slide-in via CSS.
 * Prefer this over motion.div on screens with heavy in-place updates (e.g. calendar date picks)
 * to avoid React 19 + Framer Motion DOM reconciliation errors.
 */
function SceneContainer({ children, className = "" }: SceneContainerProps) {
  return (
    <div
      className={`absolute inset-0 overflow-y-auto w-full animate-scene-enter ${className}`.trim()}
    >
      {children}
    </div>
  );
}

export default SceneContainer;
